export function toValidDate(value) {
  if (value === null || value === undefined) return null
  if (typeof value === 'string' && !value.trim()) return null

  const date = value instanceof Date ? value : new Date(value)
  const time = date.getTime()
  return Number.isNaN(time) || time <= 0 ? null : date
}

export function formatDateTime24(value, locale) {
  const date = toValidDate(value)
  if (!date) return '-'

  const dateText = date.toLocaleDateString(locale)
  const timeText = date.toLocaleTimeString(locale, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })

  return `${dateText} ${timeText}`
}
